/**
 * The directory (WALLIYO-0134): who works here.
 *
 * Its own screen, listed by every workspace's sidebar under the rule. It used to
 * be a link into a tab of Human Resources, and that was a bug rather than a
 * shortcut: only Executive and People list that screen, so following the link
 * from the other seven moved the whole console into Executive — header, sidebar
 * and all.
 *
 * A row in the shared block belongs to every workspace, the same way My time off
 * and My requests do. Nothing gates it: org structure is visible from walking
 * across the office, and gating it would make the console worse at the one
 * question everybody has without protecting anything.
 */

import type { StaffFeatureId } from "@wallyo/contracts/actions";

import { useHash } from "../../navigation/use-hash";
import { useStaff } from "../../shell/staff-context";
import { DirectoryTab, PersonTab } from "./HrScreen";
import { DIRECTORY_LINKS, parseDirectoryHash } from "./hr-route";

export function DirectoryScreen() {
  const { me } = useStaff();
  const hash = useHash();
  const route = parseDirectoryHash(hash, me.features as readonly StaffFeatureId[]);

  // A UUID is a number, so a name in that slot names nobody and opens the list
  // rather than a page that cannot load.
  // This screen is its own route, so its links stay on it. Built with the
  // Human Resources flavour they walked into #hr/directory — the Workforce
  // screen in the Executive workspace (WALLIYO-0137).
  return route.uuid === null ? (
    <DirectoryTab query={route.query} links={DIRECTORY_LINKS} />
  ) : (
    <PersonTab uuid={route.uuid} links={DIRECTORY_LINKS} />
  );
}
